import { cn } from "@/lib/utils";

/**
 * Official ATW white-field squircle lockup (`logo.png`) — navy ATW + nodes on white,
 * light gray border. Use default (no onDark) on light UI; `onDark` uses logo-white.png.
 */
const ATW_LOGO_SRC = "/brand/logo.png";
/** White mark for navy sidebar / dark chrome (same silhouette; no white plate). */
const ATW_LOGO_ON_DARK_SRC = "/brand/logo-white.png";

interface AtwLogoProps {
  size?: number;
  className?: string;
  label?: string;
  /** White mark on dark chrome (sidebar, drawer). Prefer white-field logo.png on light surfaces. */
  onDark?: boolean;
}

export function AtwLogo({
  size = 40,
  className,
  label = "ATW Hub",
  onDark = false,
}: AtwLogoProps) {
  return (
    <img
      src={onDark ? ATW_LOGO_ON_DARK_SRC : ATW_LOGO_SRC}
      alt={label}
      width={size}
      height={size}
      className={cn("atw-logo shrink-0 object-contain", onDark && "atw-logo-on-dark", className)}
      style={{ width: size, height: size }}
      decoding="async"
    />
  );
}
